import { isStackable } from "./Stackable";
/**
 * Allows robots to carry this LevelObject.
 */
export function Carryable(base) {
    return class extends base {
        constructor() {
            super(...arguments);
            this.isDropped = false;
        }
        grab(_filter) {
            if (this.isDropped) {
                this.levelMap.removeLooseObject(this);
                this.isDropped = false;
            }
            return this;
        }
        drop(target) {
            this.isDropped = this.levelMap.placeLooseObject(target, this);
            if (this.isDropped) {
                this.model.parent.remove(this.model);
                this.levelMap.world.scene.add(this.model);
            }
            else {
                const stackable = this.levelMap.getLooseObject(target);
                if (isStackable(stackable)) {
                    this.isDropped = stackable.stack(this);
                }
            }
            return this.isDropped;
        }
    };
}
